'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * The Amplitude Experiment SDK stores the experiment data in local storage
 * under the following keys. They keys are determined by Deployment ID which
 * is a stable identifier.
 *
 * (https://app.amplitude.com/experiment/housecall/deployments).
 *
 * amp-exp-$default_instance-<last 6 characters of Deployment ID>
 */
var DEV_STORAGE_KEY = 'amp-exp-$default_instance-EjlFM2';
var PROD_STORAGE_KEY = 'amp-exp-$default_instance-T0ypDR';
var getAmplitudeVaultStorageKey = function getAmplitudeVaultStorageKey() {
  try {
    if (JSON.parse(localStorage.getItem(PROD_STORAGE_KEY)) !== null) {
      return PROD_STORAGE_KEY;
    }
  } catch (err) {
    console.error('Error accessing amplitude vault key in localStorage', err);
  }

  return DEV_STORAGE_KEY;
};

exports.getAmplitudeVaultStorageKey = getAmplitudeVaultStorageKey;
